import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { sorry, userpatient } from "../Constant/Index";
import { getPatientviewnoteapi } from "../network/Network";
import { useSelector } from "react-redux";

const UserNotes = () => {
	const token = useSelector((state) => state?.Auth?.token);
	const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
	const [getUsernotes, setGetUsernotes] = useState("");

	// Get UserNotes Api
	useEffect(() => {
		getPatientviewnoteapi(orderdetail?.booking_detail?.booking_id, token).then(
			(res) => {
				setGetUsernotes(res?.data);
			},
		);
	}, []);
	console.log(getUsernotes, "kadksadk2");
	//   =====================
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link
											to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
										>
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Notes
									</h5>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={
														getUsernotes?.physician_detail?.profile_image_url
													}
													className="img-fluid profie_img"
													alt=""
												/>
												<div>
													<h4 className="main-heading-font level-6 ">
														{getUsernotes?.physician_detail?.title}
													</h4>
													<h5 className="primary-medium-font level-8 extra-color-15">
														{getUsernotes?.physician_detail?.degree_title}
													</h5>
													<h5 className="primary-medium-font level-8 extra-color-15">
														{(() => {
															const raw =
																getUsernotes?.physician_detail?.specialization;
															try {
																const arr = JSON.parse(raw);
																return Array.isArray(arr)
																	? arr.join(", ")
																	: raw;
															} catch (err) {
																return raw; // fallback if not valid JSON
															}
														})()}
													</h5>
													<h5 className="primary-medium-font level-8 extra-color-15">
														{getUsernotes?.physician_detail?.address}
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<h4 className="main-heading-font level-6 ">Notes</h4>

											{getUsernotes?.note ? (
												<p className="extra-color-16">
													{getUsernotes?.note?.note}
												</p>
											) : (
												<h4 className="main-heading-font level-6 ">
													Not Found
												</h4>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserNotes;
